import React, {useState} from 'react'
import SubHeader from '../general/SubHeader'
import ResponseMsg from '../general/ResponseMsg';

const AdminLogin = () => {
    const [loading, setLoading] = useState(false);

 const [product, setProduct] = useState('')
 const [formData, setFormData] = useState({
    mobile: '',
    pass: '',
  })
      const [response, setResponse] = useState(null);
  

  const products = ['Billing Software', 'Salon Software', 'Hotel Management'] 

const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

const handleSubmit = async (e) => {
    e.preventDefault()

    // if(product == 'Hotel Management'){
    //      setResponse('Admin Panel not exists.');
    //         setTimeout(() => {
    //                 setResponse('');
    //             }, 2000);  
    //         return;  }

    setLoading(true);

    try {
      const response = await fetch(
        'https://api.dectwincam.com/api/admin-login',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },

          body: JSON.stringify({
            mobile: formData.mobile,
            pass: formData.pass,
            product,
          }),
        }
      )

      const data = await response.json()

      console.log(data)

      if (response.ok) {
 setResponse('Login successful');
          localStorage.setItem('product', product)

        // redirect
        window.location.href = '/admin/dashboard'
      } else {
         setResponse(data.message || 'Login failed');

      }
    } catch (error) {
      console.log(error)
setResponse('Server error. Please try again.')    } finally {
      setLoading(false);
            setTimeout(() => {
                    setResponse('');
                }, 2000);
    }
  }


  return (
    <>
    <SubHeader message='Admin' />

   <section className='my-5'>
                <div className='container'>


                     <form className="row g-3 my-4 col-lg-7 mx-auto" onSubmit={handleSubmit}>
                        <div className="col-12">
                            <input type="tel" className="support-input" id="inputText4" placeholder='Mobile No*'  name='mobile'
                value={formData.mobile}
                onChange={handleChange} required />
                        </div>

                        <div className="col-12">
                            <input type="text" className="support-input" id="inputEmail4" placeholder='Account Password'  name='pass'
                value={formData.pass}
                onChange={handleChange} />
                        </div>

 <div className='col-12'>
              <select
                className='support-input text-muted'
                value={product}
                onChange={(e) => setProduct(e.target.value)}
                required
              >
                <option value='' disabled>Select Product*</option>
                {products.map((p, idx) => (
                  <option key={idx} value={p}>{p}</option>
                ))}
              </select>
            </div>

                        <button type="submit" className="header-btn w-100" disabled={loading}>
  {loading ? 'Loging in...' : 'Login Now'}
</button>


                        </form>

</div>
</section>

            {response && <ResponseMsg message={response} />}

    </>
  )
}

export default AdminLogin